<script>
    import { Link } from 'svelte-routing';
    import { slide } from 'svelte/transition';
    import { onMount } from 'svelte';

    import marked from 'marked';
    import moment from 'moment';

    export let title = '';
    export let tags = [];
    export let url = '';
    export let date = '';
    export let contents = '';
    export let files = [];
    export let showAll = false;
    export let category = 'blog';

    let article;

    $: dateFormatted = moment(date).format('D MMMM YYYY');
    $: more = contents.indexOf('[[more]]');
    $: before = more === -1 ? marked(contents) : marked(contents.substr(0, more));
    $: after = (showAll && more !== -1) ? marked(contents.substr(more + 8)) : null;
    $: visibleFiles = (files || []).filter(x => x.visible);

    function pauseAudio(except) {
        const elements = document.getElementsByTagName('audio');
        for (let element of elements) {
            if (element !== except) {
                element.pause();
            }
        }
    }

    onMount(() => {
        const elements = article.getElementsByTagName('audio');
        for (let element of elements) {
            element.addEventListener('play', () => pauseAudio(element));
        }
    });
</script>

<style lang="scss">
    .heading {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
        flex-wrap: wrap;

        .date {
            color: $subtle;
        }
    }
    
    .tags {
        display: flex;

        .list {
            flex: 1 1 auto;
        }
    }
    
    .list {
        display: flex;
        flex-wrap: wrap;
    }

    .item {
        padding: 0.5rem 1rem 0.5rem 0;
    }
</style>

<article bind:this={article} transition:slide={{duration: 200}} class="category-{category}">
    <div class="heading">
        {#if url && url !== ''}
            <h3>
                <Link to={url}>{title}</Link>
            </h3>
        {:else}
            <h2>{title}</h2>
        {/if}
        {#if date && date !== ''}
            <span class="date">{dateFormatted}</span>
        {/if}
    </div>
    {@html before}
    {#if after && showAll}
        {@html after}
    {:else if more !== -1}
        <p>
            <Link to={url}>Keep reading...</Link>
        </p>
    {/if}
    {#if visibleFiles.length > 0}
        <hr>
        <div class="list">
            {#each visibleFiles as file}
                <div class="item">
                    <a href={file.url}>{file.name}</a>
                </div>
            {/each}
        </div>
    {/if}
    {#if tags.length}
        <hr>
        <div class="tags">
            <div class="subtle item">Tagged: </div>
            <div class="list">
                {#each tags as tag}
                    <div class="item">
                        <Link to="/tags/{tag}">{tag}</Link>
                    </div>
                {/each}
            </div>
        </div>
    {/if}
    <slot/>
</article>
<hr class="divider">
